/* eslint-disable */
// Import styles - this will be separated in webpack by default

// import 'bootstrap/dist/css/bootstrap.css';
import jQuery from 'jquery';  // Import jQuery first

//import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import 'font-awesome/scss/font-awesome.scss';
// import '../sass/style.scss';
import 'masonry-layout/dist/masonry.pkgd.js';
// import Masonry from 'masonry-layout';
import 'imagesloaded/imagesloaded.pkgd.js';
import objectFitImages from 'object-fit-images';
import svg4everybody from 'svg4everybody';
import lity from 'lity';
// import 'lity/dist/lity.min.css';
import './anchor-links';

jQuery( function( $ ) {
	require( './click-to-scroll' );
	require( './ac-mobile-menu' );
	require( './flickity' );
	require( './sticky-nav' );
	require( './filter' );
	require( './mibs' );
	require( './share-links.js' );
	require( './search-filter.js' );
	require( './acf-map.js' );
	require( './gutenberg-faq.js' );
	require( './animated-section.js' );
	require( './slide-out-widget.js' );
	require( './cookie-functions.js' );
	require( './dynamics-dropdown-cascade.js')

	svg4everybody();
	objectFitImages();

	// Prevent default on lightbox clicks.
	$( '[data-lity]' ).on( 'click', function( event ) {
		event.preventDefault();
	});

	$( '.search-toggle' ).on( 'click', function () {
		$( '#search-container' ).slideToggle( 150, function () {
			$( this ).find( '.form-control' ).focus();
		});
	});

	var elem = document.querySelector( '.c-card-wrapper--archive' );

	if ( 'undefined' !== typeof ( elem ) && null !== elem ) {

		var $grid = $( '.c-card-wrapper--archive' ).masonry({
			// options
			percentPosition: true,
			itemSelector: '.c-card',
			columnWidth: '.grid-sizer',
		});

		// layout Masonry after each image loads
		$grid.imagesLoaded().progress( function () {
			$grid.masonry( 'layout' );
		});

	}

	// Active state for collapse
	$( '.collapse' ).on( 'show.bs.collapse', function ( e ) {
		$( 'a[ href="#' + e.target.id + '" ]' ).addClass( 'active' );
	});

	$( '.collapse' ).on( 'hide.bs.collapse', function ( e ) {
		$( 'a[ href="#' + e.target.id + '" ]' ).removeClass( 'active' );
	});

	// Smooth scroll
	// Select all links with hashes
	$( 'a[href*="#"]' )
	// Remove links that don't actually link to anything
		.not( '[href="#"]' )
		.not( '[href="#0"]' )
		.click( function ( event ) {
			// On-page links
			if ( location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' ) && location.hostname == this.hostname ) {
			// Figure out element to scroll to
				let target = $( this.hash );
				target     = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
				// Does a scroll target exist?
				if ( target.length ) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					let headerHeight = $( '#masthead' ).height();

					setTimeout(function() {
						$( 'html, body' ).animate({
							scrollTop: target.offset().top - headerHeight,
						}, 600, function () {
							// Callback after animation
							// Must change focus!
							let $target = $( target );
							$target.focus();
							if ( $target.is( ':focus' ) ) { // Checking if the target was focused
								return false;
							} else {
								$target.attr( 'tabindex', '-1' ); // Adding tabindex for elements not focusable
								$target.focus(); // Set focus again
							}
						});
					}, 900 );
				}
			}
		});

	// Prevent opened collapse from closing when user tries to close opened collapse
	$( '.c-approach-tabs [data-toggle="collapse"]' ).on( 'click', function( e ) {
		if ( $( this.getAttribute( 'href' ) ).hasClass( 'in' ) ) {
			// Don't close the collapse
			e.stopPropagation();
			// Prevent scroll
			e.preventDefault();
		}
	} );

	// If Url has anchor link in it compensate the scrolling by adding header height.
	if ( location.hash ) {
		setTimeout(function() {
			let target       = $( location.hash );
			let headerHeight = $( '#masthead' ).height();

			$( 'html, body' ).animate( {
				scrollTop: target.offset().top - headerHeight,
			}, 1000 );
		}, 900 );
	}
	/* eslint-enable */
} );
